import { createGlobalStyle } from 'styled-components'
import { mediaQueries } from '../MediaQueryProvider'

export const GlobalStyles = createGlobalStyle`
  .Toastify__toast-container {
    ${mediaQueries.tablet} {
      width: auto !important;
    }
  }

  .Toastify__toast {
    padding: 0 !important;
    box-shadow: none !important;
    background: none !important;
  }
`
